import axios from 'axios';
import { TYPE_RECIPIENT_ME, DELIVERY_WAY_SMS } from '../components/GiftPage/consts';

const baseUrl = process.env.GATSBY_API_URL || 'https://test-api1.periodica.press/api';

const headers = {
  'Content-Type': 'application/json',
  'Accept-Version': 'v4',
};

const EXCLUDED_CERT_TYPES = ['CERT_CUSTOM', 'CERT_COLLECT_BOOK'];

export const getGiftCards = async () => {
  const result = await axios({
    method: 'GET',
    url: `${baseUrl}/templates/gift_card`,
    headers,
  });
  const cards = result.data.filter((card) => EXCLUDED_CERT_TYPES.indexOf(card.name) === -1);
  return cards.map((card, idx) => ({
    template_id: card.id,
    slideId: idx,
    image: card.preview_url,
    backImage: card.back_page_layout,
    frontLayout: card.preview,
    isTextEnabled: card.has_text,
  }));
};

export const postSmsOnPhone = (phone) =>
  axios({
    method: 'POST',
    url: `${baseUrl}/sms/code`,
    data: { phone },
    headers,
  });

export const validateSmsCode = async (phone, code) => {
  const result = await axios({
    method: 'POST',
    url: `${baseUrl}/sms/validate`,
    data: { phone, code },
    headers,
  });
  return result.status === 200;
};

/* eslint-disable camelcase */
export const orderGift = async (
  template_id,
  name,
  phone,
  email,
  to_name,
  to_email,
  to_phone,
  message,
  price,
  previewUrl,
  client_newsletter_agreed,
  dateTime,
  timezone,
  payment_type,
  deliveryWay,
  deliveryRecipient
) => {
  const normalizedMessage = message.replaceAll('\n', '<br/>');

  // если телефон заполнен, то отправится смс и поле с имейл проигнорируется
  let toPhone = null;
  if (to_phone) {
    toPhone = to_phone;
  } else if (deliveryWay === DELIVERY_WAY_SMS && deliveryRecipient === TYPE_RECIPIENT_ME) {
    toPhone = phone;
  }

  const data = {
    template_id,
    client_newsletter_agreed,
    gift_card_info: {
      name,
      phone,
      email,
      to_name,
      to_email: to_email || email,
      ...(toPhone && { to_phone: toPhone }),
      message: normalizedMessage || ' ',
    },
    price,
    ...(previewUrl && {
      preview_url: previewUrl,
    }),
    ...(dateTime &&
      timezone && {
        schedule_info: {
          date_time: dateTime,
          timezone,
        },
      }),
    payment_type,
  };
  const result = await axios({
    method: 'POST',
    url: `${baseUrl}/gift/order`,
    data,
    headers,
  });
  return result.data;
};
/* eslint-enable camelcase */
